import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ToastService, MdbCheckboxChange, IMyOptions } from 'ng-uikit-pro-standard';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { RuteadorService } from 'src/app/services/ruteador.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { ModalClonarRecorridoComponent } from '../modal-clonar-recorrido/modal-clonar-recorrido.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatesService } from '../../../shared/services/dates.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalAddEditRutasComponent } from '../modal-add-edit-ruta/modal-add-edit-ruta.component';

enum QUERY_TYPE {
  ONLY_RUTEADOR_MANUAL = 'RUTEADOR_MANUAL',
  ONLY_RUTEADOR = 'RUTEADOR',
}

@Component({
  selector: 'ruteador-modal-asignar-automatica',
  templateUrl: './modal-asignar-automatica.component.html',
  styleUrls: ['../ruteador.component.scss'],
  providers: [SecurityService],
})
export class RuteadorModalAsignarAutomaticaComponent implements OnInit {
  @Output() onActualizarListaChoferes: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUpdateEditar: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild(ModalClonarRecorridoComponent, { static: true }) onShowModalClonarRuta: ModalClonarRecorridoComponent;
  @ViewChild('asignarAutomaticaCamionRutas', { static: true }) modalAsignarAutomaticaCamionRutas: ModalDirective;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(ModalAddEditRutasComponent, { static: true }) verAddEditRutasModal: ModalAddEditRutasComponent

  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  @Input() queryType: QUERY_TYPE = QUERY_TYPE.ONLY_RUTEADOR;
  onlyRuteador: Boolean = false;


  //Variables
  formFiltrosDocumentos: FormGroup;
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private currentPayload: any;
  private lastIndexChecked: number = -1;
  processing: boolean = false
  loading: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();
  edicionRecorrido: boolean = false;
  asignar: boolean;
  public permiteUnidadNegocio: boolean = false;
  total_documentos: any;
  documentos_pendientes: any;
  numeros_clientes: any;

  // Sistema de orden de selección para recorridos
  private recorridoSelectionOrder: number[] = [];
  private nextRecorridoSelectionOrderIndex: number = 1;

  //Lista
  listadoCamionChoferDisponible: Array<any> = null;
  listadoCamionChoferDisponibleAll: Array<any> = null;
  documentosRecorridos: Array<any> = [];
  beachesSeleccionados = [];
  recorridoDetalle: Array<any> = [];
  recorridoDetalleAsignados: Array<any> = [];
  listaDocumentosRecorridos: Array<any> = [];

  //Options
  optionsEstado: Array<any> = [];
  optionsEstadoDetalle: Array<any> = [];
  optionsComuna: Array<any> = [];
  optionsTerritorios: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private recorridoService: RecorridoService,
    private messageRendererService: MessageRendererService,
    private ruteadorService: RuteadorService,
    private datesService: DatesService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formValidatorsService: FormValidatorsService,
  ) {
    this.log = this.clog.log('AIGNACION AUTOMATICO')
  }

  ngOnInit() {
    this.createForm();
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;
  }

  ngOnDestroy() { }

  show(beachesSeleccionados, documentosRecorridos, unidad_negocio_codigo: number, fecha, fechaHasta, editar: boolean = false) {
    this.clearAll();
    this.beachesSeleccionados = beachesSeleccionados;
    this.documentosRecorridos = documentosRecorridos;
    this.edicionRecorrido = editar;
    this.currentPayload = {
      unidad_negocio_codigo,
      fecha,
      rutEmpresa: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
      editar,
    };
    this.formFiltrosDocumentos.get("filtroFechaDesde").setValue(fecha)
    this.formFiltrosDocumentos.get("filtroFechaHasta").setValue(fechaHasta)
    // this.obtenerDocumentosRecorridoByFiltro();
    this.obtenerChoferesDisponibles();
    this.modalAsignarAutomaticaCamionRutas.show();
  }

  changeComuna(selectedComuna: any) {
    const comunaSeleccionada = selectedComuna
    this.obtenerResumenDocumentos(comunaSeleccionada)
  }

  changeVendedor(selectedVendedor: any) {
    const vendedorSeleccionado = selectedVendedor
    this.obtenerResumenDocumentos(null, vendedorSeleccionado)
  }

  changeTerritorio(selectedTerritorio: any) {
    const territorioSeleccionado = selectedTerritorio
    this.obtenerResumenDocumentos(null, null, territorioSeleccionado)
  }

  clearAll() {
    this.loading = true;
    this.listadoCamionChoferDisponibleAll = [];
    this.listadoCamionChoferDisponible = [];
    this.lastIndexChecked = -1;

    // Limpiar orden de selección de recorridos
    this.recorridoSelectionOrder = [];
    this.nextRecorridoSelectionOrderIndex = 1;
  }

  obtenerChoferesDisponibles() {
    // var fecha = "09-09-2020"
    const self = this;
    const inputParams = this.currentPayload;

    this.ruteadorService.obtenerCamionChoferDisponible(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;

      this.listadoCamionChoferDisponibleAll = registros;

      if (this.listadoCamionChoferDisponibleAll.length == 0) {
        this.listadoCamionChoferDisponibleAll = [];
        this.toastService.warning('No existen Rutas a la fecha');
      }

      // this.listadoCamionChoferDisponibleAll = _.sortBy(this.listadoCamionChoferDisponibleAll, ['recorrido_codigo'], ['desc'])

      this.paginationContext.RecordsCount = this.listadoCamionChoferDisponibleAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listadoCamionChoferDisponibleAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.seleccion = false
        mov.additionalInfo.checked = false
        mov.additionalInfo.index = index
      })
      this.showPage(this.paginationContext.CurrentPage);
      this.loading = false;
      this.buscarPorFiltros();
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listadoCamionChoferDisponible = _.slice(this.listadoCamionChoferDisponibleAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  checkAllChange({ checked }) {
    if (checked) {
      // Seleccionar todos: mantener el orden de la lista
      this.recorridoSelectionOrder = [];
      this.nextRecorridoSelectionOrderIndex = 1;

      this.listadoCamionChoferDisponibleAll.forEach((mov, index) => {
        mov.seleccion = true;
        mov.additionalInfo.checked = true;
        mov.additionalInfo.selectionOrder = this.nextRecorridoSelectionOrderIndex++;
        this.recorridoSelectionOrder.push(index);
      });

      this.listadoCamionChoferDisponible.forEach((mov, index) => {
        mov.seleccion = true;
        mov.additionalInfo.checked = true;
        // Encontrar el índice en el array completo
        const fullArrayIndex = this.listadoCamionChoferDisponibleAll.findIndex(item =>
          item.additionalInfo.index === mov.additionalInfo.index
        );
        if (fullArrayIndex !== -1 && this.listadoCamionChoferDisponibleAll[fullArrayIndex].additionalInfo.selectionOrder) {
          mov.additionalInfo.selectionOrder = this.listadoCamionChoferDisponibleAll[fullArrayIndex].additionalInfo.selectionOrder;
        }
      });
    } else {
      // Deseleccionar todos
      this.recorridoSelectionOrder = [];
      this.nextRecorridoSelectionOrderIndex = 1;

      this.listadoCamionChoferDisponibleAll.forEach(mov => {
        mov.seleccion = false;
        mov.additionalInfo.checked = false;
        delete mov.additionalInfo.selectionOrder;
      });

      this.listadoCamionChoferDisponible.forEach(mov => {
        mov.seleccion = false;
        mov.additionalInfo.checked = false;
        delete mov.additionalInfo.selectionOrder;
      });
    }
  }

  checkItem({ index, checked }) {
    const selectedMain: any = this.listadoCamionChoferDisponibleAll.filter(p => p.additionalInfo.index === index)[0]
    const selected = this.listadoCamionChoferDisponible.filter(p => p.additionalInfo.index === index)[0]

    if (!checked) {
      // Seleccionar elemento
      selectedMain.seleccion = true;
      selectedMain.additionalInfo.checked = true;
      selectedMain.additionalInfo.selectionOrder = this.nextRecorridoSelectionOrderIndex++;

      if (selected) {
        selected.seleccion = true;
        selected.additionalInfo.checked = true;
        selected.additionalInfo.selectionOrder = selectedMain.additionalInfo.selectionOrder;
      }

      // Agregar al orden de selección
      const mainArrayIndex = this.listadoCamionChoferDisponibleAll.indexOf(selectedMain);
      if (mainArrayIndex !== -1 && !this.recorridoSelectionOrder.includes(mainArrayIndex)) {
        this.recorridoSelectionOrder.push(mainArrayIndex);
      }
    } else {
      // Deseleccionar elemento
      selectedMain.seleccion = false;
      selectedMain.additionalInfo.checked = false;
      delete selectedMain.additionalInfo.selectionOrder;

      if (selected) {
        selected.seleccion = false;
        selected.additionalInfo.checked = false;
        delete selected.additionalInfo.selectionOrder;
      }

      // Remover del orden de selección
      const mainArrayIndex = this.listadoCamionChoferDisponibleAll.indexOf(selectedMain);
      const orderIndex = this.recorridoSelectionOrder.indexOf(mainArrayIndex);
      if (orderIndex !== -1) {
        this.recorridoSelectionOrder.splice(orderIndex, 1);
      }
    }
  }

  // Funciones para manejar la selección de documentos
  checkAllDocumentosChange({ checked }) {
    this.listaDocumentosRecorridos.forEach(mov => {
      if (mov.folio_recorrido_Detalle === 0) { // Solo documentos no asignados
        if (!mov.additionalInfo) {
          mov.additionalInfo = { checked: false, index: 0 };
        }
        mov.additionalInfo.checked = checked;
        mov.seleccionado = checked;
      }
    });
  }

  checkDocumentoItem(documento: any, checked: boolean) {
    if (!documento.additionalInfo) {
      documento.additionalInfo = { checked: false, index: 0 };
    }

    documento.additionalInfo.checked = checked;
    documento.seleccionado = checked;
  }

  // Función para verificar si un documento está seleccionado
  isDocumentoSelected(documento: any): boolean {
    const isCheckedViaAdditionalInfo = (documento.additionalInfo && documento.additionalInfo.checked === true);
    const isSelectedViaProperty = (documento.seleccionado === true);
    return isCheckedViaAdditionalInfo || isSelectedViaProperty;
  }

  // Función para obtener solo los documentos seleccionados
  getSelectedDocumentos(): any[] {
    return this.listaDocumentosRecorridos.filter(doc =>
      doc.folio_recorrido_Detalle === 0 && this.isDocumentoSelected(doc)
    );
  }

  // Función para obtener el conteo de documentos seleccionados
  getSelectedDocumentosCount(): number {
    return this.getSelectedDocumentos().length;
  }

  // Funciones para obtener recorridos en orden de selección
  getRecorridosInSelectionOrder(): any[] {
    const selectedRecorridos = this.recorridoSelectionOrder
      .map(index => this.listadoCamionChoferDisponibleAll[index])
      .filter(recorrido => recorrido && recorrido.additionalInfo && recorrido.additionalInfo.checked === true)
      .sort((a, b) => {
        const aOrder = (a.additionalInfo && a.additionalInfo.selectionOrder) ? a.additionalInfo.selectionOrder : 0;
        const bOrder = (b.additionalInfo && b.additionalInfo.selectionOrder) ? b.additionalInfo.selectionOrder : 0;
        return aOrder - bOrder;
      });

    return selectedRecorridos;
  }

  // Función para obtener conteo de recorridos seleccionados
  getSelectedRecorridosCount(): number {
    return this.getRecorridosInSelectionOrder().length;
  }

  //ABRIR MODAL DE CLONAR RECORRIDO
  ClonarRecorrido() {
    const selectFilter = this.listadoCamionChoferDisponibleAll.filter((x) => x.additionalInfo.checked == true);
    this.onShowModalClonarRuta.show(selectFilter);
  }

  AsignarAutomaticaCamion() {
    this.beachesSeleccionados;
    this.processing = true
    const { filtroEstado, filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value

    // CAMBIO: Obtener recorridos en el orden que el usuario los seleccionó
    const listadoRecorridos = _.cloneDeep(this.getRecorridosInSelectionOrder());

    // CAMBIO: Obtener solo los documentos seleccionados por el usuario mediante checkboxes
    let listadoDocumento = _.cloneDeep(this.getSelectedDocumentos());

    // Si no hay documentos seleccionados manualmente, usar fallback con filtros
    if (listadoDocumento.length === 0) {
      listadoDocumento = _.cloneDeep(this.listaDocumentosRecorridos.filter(doc => doc.folio_recorrido_Detalle === 0));

      // Aplicar filtros dinámicos solo en fallback
      if (filtroComuna && filtroComuna.length > 0) {
        const codigosComuna = filtroComuna.map((comuna) => comuna);
        listadoDocumento = listadoDocumento.filter((doc) =>
          codigosComuna.includes(doc.comuna_codigo)
        );
      }

      if (filtroVendedor && filtroVendedor.length > 0) {
        const codigosVendedor = filtroVendedor.map((vendedor) => vendedor);
        listadoDocumento = listadoDocumento.filter((doc) =>
          codigosVendedor.includes(doc.vendedor_codigo)
        );
      }

      if (filtroTerritorio && filtroTerritorio.length > 0) {
        const codigosTerritorio = filtroTerritorio.map((territorio) => territorio);
        listadoDocumento = listadoDocumento.filter((doc) =>
          codigosTerritorio.includes(doc.territorio_codigo)
        );
      }
    }

    // Validaciones
    if (listadoRecorridos.length === 0) {
      this.showInfo('Seleccione un recorrido');
      this.processing = false
      return;
    }

    if (listadoDocumento.length === 0) {
      this.showInfo('Seleccione al menos un documento para asignar a los recorridos');
      this.processing = false
      return;
    }

    console.log('=== DEBUG ASIGNACIÓN AUTOMÁTICA ===');
    console.log('Documentos seleccionados por usuario:', listadoDocumento.length);
    console.log('Recorridos seleccionados por usuario:', listadoRecorridos.length);
    console.log('Orden de recorridos respetado:', listadoRecorridos.map((rec, index) =>
      `${index + 1}. Recorrido: ${rec.recorrido_codigo} - Patente: ${rec.patente}`));
    console.log('Folios seleccionados:', listadoDocumento.map(doc => doc.folio));

    // Limpiar propiedades innecesarias de los documentos
    listadoDocumento.forEach(mov => {
      delete mov.__typename
      delete mov.rut_receptor
      delete mov.comuna
      delete mov.vendedor
      delete mov.territorio
      delete mov.folio_recorrido_Detalle
      delete mov.fecha_emision
      delete mov.nombre_cliente
      delete mov.territorio
      delete mov.estado_cliente
      delete mov.estado
      delete mov.recorrido_codigo
      delete mov.direccion_completa
      delete mov.total_unidad
      delete mov.additionalInfo // Limpiar info de selección
      delete mov.seleccionado // Limpiar info de selección
      mov.monto_documento = mov.total_monto
      delete mov.total_monto
    });

    // Limpiar propiedades innecesarias de los recorridos
    listadoRecorridos.forEach(mov => {
      delete mov.additionalInfo
      delete mov.__typename
      delete mov.seleccion
    });

    const inputParams = {
      listadoDocumentos: listadoDocumento,
      listadoRecorridos: listadoRecorridos
    };

    this.ruteadorService.asignacionAutomatica(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      this.processing = false

      if (!ok) {
        this.showError('Ha ocurrido un problema en la asignación. ' + mensajes.texto);
        this.recorridoDetalle = [];
        return;
      }

      if (respuesta.status == 'NOK') {
        this.showError(
          'El camión se encuentra con . ' + respuesta.message + ' La asignación automatica de documento(s) se ha detenido.'
        );

        this.cerrarModal();
      }

      if (respuesta.status == 'OK') {
        this.showSuccess('La asignación de documento(s) al camión ha sido realizada con éxito.');
        this.cerrarModal();
      }

      // //LIMPIAR ARREGLO
      this.listadoCamionChoferDisponibleAll = []
      this.listadoCamionChoferDisponible = []
      // this.recorridoDetalle.splice(0, this.recorridoDetalle.length);
      this.onSuccess.emit();
    });
  }

  ruteadorMap(listado) {
    const self = this;

    var flag = false;

    self.documentosRecorridos.forEach((element1) => {
      self.beachesSeleccionados.forEach((element2) => {
        if (element1.latitud.trim() === element2.latitud.trim()) {
          if (element1.folio_recorrido_Detalle > 0) {
            this.recorridoDetalleAsignados.push({
              recorrido_codigo: listado[0].recorrido_codigo,
              vendedor_codigo: element1.vendedor_codigo, //
              rut_emisor: element1.rut_emisor, //
              folio: element1.folio, //
              tipo_dte_codigo: element1.tipo_dte_codigo, //
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              direccion_codigo: element1.direccion_codigo,
              monto_documento: element1.monto_documento, //lstCamChof[0].total_facturas
            });
            flag = true;
          } else {
            this.recorridoDetalle.push({
              recorrido_codigo: listado[0].recorrido_codigo,
              vendedor_codigo: element1.vendedor_codigo, //
              rut_emisor: element1.rut_emisor, //
              folio: element1.folio, //
              tipo_dte_codigo: element1.tipo_dte_codigo, //
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              direccion_codigo: element1.direccion_codigo,
              monto_documento: element1.monto_documento, //lstCamChof[0].total_facturas
            });
          }
        }
      });
    });

    for (var i = 0; i < this.recorridoDetalle.length; i++) {
      delete this.recorridoDetalle[i]['__typename'];
    }

    if (!flag && this.recorridoDetalle.length > 0) {
      this.asignar = true;
    } else if (flag) {
      this.showWarning('Ha seleccionado documentos que ya se encuentra(n) asignado(s)');
      this.recorridoDetalle.splice(0, this.recorridoDetalle.length);
    }
  }

  editarRecorrido(recorrido: any): void {
    this.verAddEditRutasModal.showEdit(recorrido);
  }

  confirmEliminar(recorrido: any) {
    const self = this;

    const title = 'Eliminar';
    const message = '¿Está seguro de eliminar registro?';

    this.modalConfirm.showWithInlineConfig(title, message, () => {
      const _recorrido = _.cloneDeep(recorrido);
      delete _recorrido.__typename;
      const inputParams = {
        entidad: {
          chofer_rut: recorrido.chofer_rut,
          codigo: recorrido.recorrido_codigo,
          camion_patente: recorrido.patente,
          sucursal_codigo: this.sucursalCodigo,
          rut_empresa: this.rutEmpresa,
          activo: recorrido.checked,
          //unidad_negocio: this.formRuta.get('negocio').value
        },
      };
      this.recorridoService.eliminar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.toastService.success('Operación realizada');
        this.onCargarRuta();

      });
      // setTimeout(() => this.buscarPorFiltros(), 1000);
    });
    this.onCargarRuta();
  }

  showWarning(mensaje) {
    const options = { opacity: 1 };
    this.toastService.warning(mensaje, 'Mensaje Advertencia!', options);
  }

  showInfo(mensaje) {
    const options = { opacity: 1 };
    this.toastService.info(mensaje, 'Mensaje Información!', options);
  }

  showSuccess(mensaje) {
    const options = { opacity: 1 };
    this.toastService.success(mensaje, 'Mensaje Éxito!', options);
  }

  showError(mensaje) {
    const options = { opacity: 1 };
    this.toastService.error(mensaje, 'Mensaje Error!', options);
  }

  requestShowModalRutas() {
    this.clearRecorridoSeleccionado();
    //this.onShowModalRutasRequest.emit();
    this.verAddEditRutasModal.showAdd();
  }
  clearRecorridoSeleccionado(): void {
    this.recorridoService.recorridoSeleccionado$.emit(null);
  }

  UpdateEditarRutas() {
    this.obtenerChoferesDisponibles();
  }

  cerrarModal(): void {
    this.formValidatorsService.reset(this.formFiltrosDocumentos);
    const { currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.listaDocumentosRecorridos = [];
    this.optionsComuna = [];
    this.optionsVendedor = [];
    this.optionsTerritorios = [];
    this.formFiltrosDocumentos.get('filtroFechaDesde').setValue(currentDate);
    this.formFiltrosDocumentos.get('filtroFechaHasta').setValue(currentDate);

    // Limpiar orden de selección de recorridos
    this.recorridoSelectionOrder = [];
    this.nextRecorridoSelectionOrderIndex = 1;

    this.clearRecorridoSeleccionado();
    this.modalAsignarAutomaticaCamionRutas.hide();
  }

  buscarPorFiltros() {
    if (this.permiteUnidadNegocio && !this.formFiltrosDocumentos.get('unidad_negocio_codigo').value) {
      return;
    }
    this.obtenerDocumentosRecorridoByFiltro();
  }

  limpiarFiltros() {
    this.formValidatorsService.reset(this.formFiltrosDocumentos);
    const { currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.listaDocumentosRecorridos = [];
    this.optionsComuna = [];
    this.optionsVendedor = [];
    this.optionsTerritorios = [];
    this.formFiltrosDocumentos.get('filtroFechaDesde').setValue(currentDate);
    this.formFiltrosDocumentos.get('filtroFechaHasta').setValue(currentDate);
    this.buscarPorFiltros();
  }

  public myDatePickerOptions: IMyOptions = {
    editableDateField: false,
  };

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formFiltrosDocumentos = this.fb.group({
      filtroFechaDesde: [currentDate],
      filtroFechaHasta: [currentDate],
      fechafiltroDetalleRecorrido: [currentDate],
      fechafiltroDetalleRecorridoHasta: [currentDate],
      filtroEstado: [''],
      estadofiltroDetalleRecorrido: [''],
      filtroComuna: [''],
      filtroVendedor: [''],
      filtroTerritorio: [''],
      unidad_negocio_codigo: [null],
    });
  }



  obtenerDocumentosRecorridoByFiltro() {
    const { filtroEstado, filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formFiltrosDocumentos.get('filtroFechaDesde').value,
      fechaHasta: this.formFiltrosDocumentos.get('filtroFechaHasta').value,
      estado: 2,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: (filtroComuna === '' || filtroComuna === null || filtroComuna === undefined) ? [] : filtroComuna,
      vendedor_codigo: (filtroVendedor === '' || filtroVendedor === null || filtroVendedor === undefined) ? [] : filtroVendedor,
      territorio_codigo: (filtroTerritorio === '' || filtroTerritorio === null || filtroTerritorio === undefined) ? [] : filtroTerritorio
    }

    this.ruteadorService.obtenerDocumentosbyFiltros(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.listaDocumentosRecorridos = registros;

      this.documentosRecorridos = [];
      this.documentosRecorridos = this.listaDocumentosRecorridos.filter(doc => doc.folio_recorrido_Detalle === 0);
      if (this.documentosRecorridos.length > 0) {
        this.showSuccess('Documentos actualizados');

        // Inicializar additionalInfo para cada documento
        this.listaDocumentosRecorridos.forEach((documento, index) => {
          documento.additionalInfo = {
            checked: false,
            index: index
          };
          documento.seleccionado = false;
        });

        this.obtenerResumenDocumentos();

        //Filtro de Comunas de Documentos
        this.optionsComuna = [];
        let sel2: any;
        let listaComunaDocumentoDistinct = this.documentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.comuna === thing.comuna) === i);
        listaComunaDocumentoDistinct.forEach((element) => {
          sel2 = { value: element.comuna_codigo, label: element.comuna };
          this.optionsComuna.push(sel2);
        });

        // Filtro Vendedor Documento
        this.optionsVendedor = [];
        let sel3: any;
        let listaVendedorDocumentoDistinct = this.documentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.vendedor === thing.vendedor) === i);
        listaVendedorDocumentoDistinct.forEach((element) => {
          sel3 = { value: element.vendedor_codigo, label: element.vendedor };
          this.optionsVendedor.push(sel3);
        });

        // Filtro Territorio Documento
        this.optionsTerritorios = [];
        let sel4: any;
        let listaTerritorioDocumentoDistinct = this.documentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.territorio === thing.territorio) === i);
        listaTerritorioDocumentoDistinct.forEach((element) => {
          sel4 = { value: element.territorio_codigo, label: element.territorio };
          this.optionsTerritorios.push(sel4);
        });
        this.log('DOCUMENTOS', JSON.stringify(this.documentosRecorridos));
        //this.initDrawingManager(this.globalMap);
      } else {
        this.showInfo('Actualmente no posee documentos para generar recorrido.');
      }

    });
  }

  obtenerDocumentosRecorridoByFiltrActualizado() {
    const { filtroEstado, filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formFiltrosDocumentos.get('filtroFechaDesde').value,
      fechaHasta: this.formFiltrosDocumentos.get('filtroFechaHasta').value,
      estado: 2,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: (filtroComuna === '' || filtroComuna === null || filtroComuna === undefined) ? [] : filtroComuna,
      vendedor_codigo: (filtroVendedor === '' || filtroVendedor === null || filtroVendedor === undefined) ? [] : filtroVendedor,
      territorio_codigo: (filtroTerritorio === '' || filtroTerritorio === null || filtroTerritorio === undefined) ? [] : filtroTerritorio
    }

    this.ruteadorService.obtenerDocumentosbyFiltros(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.listaDocumentosRecorridos = registros;

      this.documentosRecorridos = [];
      this.documentosRecorridos = this.listaDocumentosRecorridos.filter(doc => doc.folio_recorrido_Detalle === 0);
      if (this.documentosRecorridos.length > 0) {
        this.showSuccess('Documentos actualizados');

        //this.obtenerResumenDocumentos();
        this.log('DOCUMENTOS', JSON.stringify(this.documentosRecorridos));
        //this.initDrawingManager(this.globalMap);
      } else {
        this.showInfo('Actualmente no posee documentos para generar recorrido.');
      }

    });
  }

  obtenerResumenDocumentos(comunaSeleccionada?: any, vededorSelecciondo?: any, territorioSelecciondo?: any) {
    //let comSeleccionada = [];
    if (comunaSeleccionada === undefined || comunaSeleccionada === null || comunaSeleccionada === '') {
      comunaSeleccionada = []
    }
    if (vededorSelecciondo === undefined || vededorSelecciondo === null || vededorSelecciondo === '') {
      vededorSelecciondo = []
    }
    if (territorioSelecciondo === undefined || territorioSelecciondo === null || territorioSelecciondo === '') {
      territorioSelecciondo = []
    }
    const { filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formFiltrosDocumentos.get('filtroFechaDesde').value,
      fechaHasta: this.formFiltrosDocumentos.get('filtroFechaHasta').value,
      estado: 2,
      comuna_codigo: comunaSeleccionada.length > 0 ? comunaSeleccionada : (filtroComuna === '' || filtroComuna === null || filtroComuna === undefined) ? [] : filtroComuna,
      vendedor_codigo: vededorSelecciondo.length > 0 ? vededorSelecciondo : (filtroVendedor === '' || filtroVendedor === null || filtroVendedor === undefined) ? [] : filtroVendedor,
      territorio_codigo: territorioSelecciondo.length > 0 ? territorioSelecciondo : (filtroTerritorio === '' || filtroTerritorio === null || filtroTerritorio === undefined) ? [] : filtroTerritorio
    }
    this.ruteadorService.obtenerResumenDocumentos(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      var resumen = registros;


      if (resumen.length > 0) {
        this.total_documentos = resumen[0].total_documentos;
        //this.documentos_entregados = resumen[0].documentos_entregados;
        this.documentos_pendientes = resumen[0].documentos_pendientes;
        this.numeros_clientes = resumen[0].numeros_clientes;
      }
    });
  }

  onCargarRuta() {
    this.obtenerChoferesDisponibles();
    this.onActualizarListaChoferes.emit();
  }
}
